module.exports = __webpack_public_path__ + "static/portfolio-mas-2-f076a2ad0783c80be787b9074408d826.jpg";